const MEDIA_ORIGIN = "https://api.gamezacademy.pk";

function pickString(...values) {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value.trim();
    if (value && typeof value === "object") {
      const nested = pickString(
        value.url,
        value.src,
        value.path,
        value.thumbnail,
        value.image,
      );
      if (nested) return nested;
    }
  }
  return "";
}

export function getMediaThumbnail(item) {
  if (!item || typeof item !== "object") return "";
  const raw = pickString(
    item.thumbnail,
    item.thumbnail_url,
    item.thumbnailUrl,
    item.image,
    item.image_url,
    item.imageUrl,
    item.cover,
    item.cover_image,
    item.poster,
    item.thumb,
  );
  if (!raw) return "";
  if (/^(https?:|blob:|data:)/i.test(raw)) return raw;
  if (raw.startsWith("//")) return `https:${raw}`;
  return `${MEDIA_ORIGIN}/${raw.replace(/^\/+/, "")}`;
}

export const getPodcastThumbnail = getMediaThumbnail;
